import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import ResetPasswordComponent from './components/ResetPasswordComponent';

type TResetPasswordAppProps = {
  environment: any;
};

const ResetPasswordApp = ({ environment }: TResetPasswordAppProps) => (
  <EnvironmentProvider value={environment}>
    <ResetPasswordComponent />
  </EnvironmentProvider>
);

export default ResetPasswordApp;
